module.exports = __webpack_public_path__ + "img/shibetore.35ea581b.png";